<div class="m-3">
  <h1>Workers' Compensation Exemption Registration</h1>
</div>
<div fxLayoutAlign="center" style="margin-top: 20px;">
  <h1 *ngIf="applicationType  == 'intial'">Intial Application</h1>
  <h1 *ngIf="applicationType  == 'renewal'">Renewal Application</h1>
  <h1 *ngIf="applicationType  == 'requestcopy'">Request a Copy</h1>
  <h1 *ngIf="applicationType  == 'subsequent'">Subsequent  Application</h1>
  <h1 *ngIf="applicationType  == 'renewalsubsequent'">Renewal Subsequent Application</h1>
  <h1 *ngIf="applicationType  == 'reinstatement'">Reinstatement Application</h1>
  <h1 *ngIf="applicationType  == 'subsequentreinstatement'">Subsequent Reinstatement Application</h1>
  <h1 *ngIf="applicationType  == 'corrections'">Corrections Application</h1>
  <h1 *ngIf="applicationType  == 'voluntaryrevocation'">Voluntary Revocation Application</h1>
</div>
<div fxLayoutAlign="center" style="margin-top: 10px;color: red;">
  <p *ngIf="errorMsg  != ''">{{errorMsg}}</p>
</div>
<form [formGroup]="form" style="margin-bottom: 160px">
    <div *ngIf="requestType  == 'requestcopy' || (requestType  == 'renewal' && !isRegValidated)" fxLayout="row" class="mt-3"
    fxLayoutAlign="center">
    <div class="initial-questions">
      <div fxLayout="row" fxLayoutAlign="center">
        <mat-form-field style="min-width: 300px">
          <mat-label>{{regText}}
          </mat-label>
          <input matInput [placeholder]="regText" formControlName="registrationControlNumber" value="">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div *ngIf="requestType  == 'intial' || (requestType  == 'renewal' && isRegValidated)" fxLayout="row" fxLayoutAlign="center">
    <div class="initial-questions">
      <div fxLayoutAlign="center">
        <h3>Are you engaged in the construction industry?</h3>
      </div>
      <div fxLayoutAlign="center">
        <mat-radio-group aria-label="Select an option" formControlName="engagedConstruction">
          <mat-radio-button value="1">Yes</mat-radio-button>
          <mat-radio-button value="2">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>

 
  <div fxLayout="row" class="mt-3" fxLayoutAlign="center" *ngIf="form.controls.engagedConstruction.value == 1">
    <mat-form-field style="max-width: 500px">
      <mat-label>Select all that apply</mat-label>
      <mat-select [formControl]="doctypeControl" multiple style="width: 100%">

        <mat-select-trigger>
          <mat-chip-list>
            <mat-chip *ngFor="let doctype of doctypeControl.value" [removable]="true" (removed)="onDocRemoved(doctype)">
              {{ doctype.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </mat-select-trigger>
        <mat-option *ngFor="let doctype of docTypeList" [value]="doctype">{{doctype?.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="requestType  == 'renewal'" fxLayout="row" class="mt-3" fxLayoutAlign="center">   
  <label for="g-recaptcha-response" style="display:none;">Please confirm you are not a robot:</label>
  <re-captcha id="recaptcha" name="recaptcha" formControlName="recaptcha" required></re-captcha>
</div>
  <div *ngIf="requestType  == 'requestcopy'" fxLayout="row"
  class="mt-3" fxLayoutAlign="center">
  <label for="g-recaptcha-response" style="display:none;">Please confirm you are not a robot:</label>
  <re-captcha id="recaptcha" name="recaptcha" formControlName="recaptcha" required></re-captcha>
</div>
  <div *ngIf="requestType  == 'requestcopy'" fxLayout="row" class="mt-3" fxLayoutAlign="center">
    <button *ngIf="form.valid" [disabled]="isContinueClicked" (click)="onRequestCopy()"
      mat-raised-button color="primary">Continue</button>
  </div>
  <div *ngIf="requestType  == 'renewal'" fxLayout="row" class="mt-3" fxLayoutAlign="center">
    <button *ngIf="form.valid" [disabled]="isContinueClicked" (click)="onRenwalValidation()"
      mat-raised-button color="primary">Continue</button>
  </div>
  <div *ngIf="requestType  == 'intial' && form.controls.engagedConstruction.value  == 1 && doctypeControl.value.length > 0 " fxLayout="row"
    class="mt-3" fxLayoutAlign="center">
    <label for="g-recaptcha-response" style="display:none;">Please confirm you are not a robot:</label>
    <re-captcha id="recaptcha" name="recaptcha" formControlName="recaptcha" required></re-captcha>
  </div>
  <div *ngIf="requestType  == 'intial'" fxLayout="row" class="mt-3" fxLayoutAlign="center">
    <button [disabled]="isContinueClicked" (click)="onContinue()"
      *ngIf="form.valid && form.controls.engagedConstruction.value  == 1 && doctypeControl.value.length > 0 "
      mat-raised-button color="primary">Continue</button>
    <button *ngIf="form.controls.engagedConstruction.value  == 2" (click)=" onCancel()" mat-raised-button color="primary">Cancel</button>
  </div>
</form>
